import { PanelLeftClose, PanelLeftOpen } from 'lucide-react'
import { Button } from '@quebon/ui/components/button'

interface Props {
  title: string
  collapsed: boolean
  controlsId: string
  collapseLabel: string
  expandLabel: string
  onToggle?: () => void
}
export function CollapsibleListHeader({
  title,
  collapsed,
  controlsId,
  collapseLabel,
  expandLabel,
  onToggle,
}: Props) {
  return (
    <header className="flex h-11 items-center justify-between border-b border-border bg-muted/60 px-3">
      {!collapsed ? (
        <h2 className="min-w-0 truncate text-sm font-semibold text-foreground">{title}</h2>
      ) : null}
      {onToggle ? (
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          className={collapsed ? 'mx-auto' : undefined}
          aria-label={collapsed ? expandLabel : collapseLabel}
          aria-controls={controlsId}
          aria-expanded={!collapsed}
          title={collapsed ? expandLabel : collapseLabel}
          onClick={onToggle}
        >
          {collapsed ? <PanelLeftOpen /> : <PanelLeftClose />}
        </Button>
      ) : null}
    </header>
  )
}
